export const ConsularAffairsTitle: string = "Consular Affairs Center";
